import { NotionVariant } from 'components/Notion/Notion';
import BaseSvgWrapper from './BaseSvgWrapper';
import Loader from './Loader';

type Props = {
  variant: NotionVariant;
};

const NotionIcon = ({ variant, ...props }: Props): JSX.Element =>
  variant === NotionVariant.LOADING ? (
    <BaseSvgWrapper>
      <Loader />
    </BaseSvgWrapper>
  ) : (
    <BaseSvgWrapper {...props}>
      {variant === NotionVariant.SUCCESS ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11.003 16L18.073 8.929L16.659 7.515L11.003 13.172L8.174 10.343L6.76 11.757L11.003 16Z" />
        </svg>
      ) : variant === NotionVariant.INFO ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z" />
        </svg>
      ) : variant === NotionVariant.WARNING ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" />
        </svg>
      ) : variant === NotionVariant.DANGER ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" />
        </svg>
      ) : null}
    </BaseSvgWrapper>
  );

export default NotionIcon;
